import fileDownload from "js-file-download";
import React, { useContext, useEffect, useState } from "react";
import { getMoisString } from "../../services/Constante";
import { findOne, getfile } from "../../services/ShareDetails__Servive";
import notifyContext from "../Context/notifyContext";
import PdfRender from "../PdfRender/PdfRender";
import Loader from "../Loader/Loader";

const ModalShareDetails = ({ shareDetailsId = 0, initialValue = null }) => {
  const notify = useContext(notifyContext);
  const [selectedFile, setSelectedFile] = useState(null);
  const [shareDetails, setShareDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (initialValue) {
      setShareDetails({ ...initialValue });
      fecthFile(initialValue.chemin);
    } else if (shareDetailsId > 0) {
      fetchOne(shareDetailsId);
    } else {
      setShareDetails(null);
    }
  }, [initialValue, shareDetailsId]);

  const fetchOne = async (shareDetailsId) => {
    findOne(shareDetailsId)
      .then((response) => {
        setShareDetails(response.data);
        if (response.data.filename) {
          fecthFile(response.data.filename);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };

  const fecthFile = async (filename) => {
    getfile(filename)
      .then((response) => {
        setSelectedFile(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {shareDetails && (
        <div className="shareDetails-view-modal">
          <div className="preview">
            {selectedFile ? (
              <>
                <button
                  className="btn download"
                  onClick={() =>
                    fileDownload(selectedFile, shareDetails.nameDownload)
                  }
                >
                  Télécharger
                </button>
                <PdfRender file={selectedFile} />
              </>
            ) : (
              <p>Aucun aperçu disponible</p>
            )}
          </div>
          <div className="infos">
            <div className="infos__item">
              <p className="label">Message : </p>
              <p className="value">{shareDetails.message}</p>
            </div>
            <div className="infos__item">
              <p className="label">Client : </p>
              <p className="value">{shareDetails.share.client.nom}</p>
            </div>
            <div className="infos__item">
              <p className="label">Partage : </p>
              <p className="value">
                {getMoisString(shareDetails.share.mounth) +
                  " " +
                  shareDetails.share.year}
              </p>
            </div>
            <div className="infos__item">
              <p className="label">Envoyé le : </p>
              <p className="value">{` ${new Date(
                shareDetails.dateCreate
              ).toLocaleDateString("fr-Fr")} à ${shareDetails.timeCreate} `}</p>
            </div>
          </div>
        </div>
      )}

      {isLoading && <Loader loadingMsg="Chargement..." />}
    </>
  );
};

export default ModalShareDetails;
